module.exports = __webpack_public_path__ + "img/moose-tracks.6352f777.png";